import * as Configuration from '../../../../../../app.constants.js';

export class ImageMapService {
  constructor($http) {
    this.$http = $http;
  }

  generateImageVariations(companyId, siteId, file) {
    let endpoint = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/line/' + siteId + '/upload-imagemap/';

    var formData = new FormData();
    formData.append('image', file);

    return this.$http.post(endpoint, formData, {
      // force the content-type to be multipart/formdata to send the image, and not JSON by default
      headers: { 'Content-Type': undefined }
    });
  }

  /**
   * Return the width of the image in a callback
   * @param file the image file
   * @param successFn function where the width is returned
   * @param errorFn function called if an error occurs
   */
  getImageWidthAsync(file, successFn, errorFn) {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = reader.result;
      image.onload = () => {
        var width = image.width;
        successFn(width);
      };
      image.onerror = (e) => {
        errorFn(e);
      };
    };
    reader.onerror = (e) => {
      errorFn(e);
    };
  }

  static ImageMapFactory($http) {
    return new ImageMapService($http);
  }
}

ImageMapService.ImageMapFactory.$inject = ['$http'];
